import InformesFuncionalidadesForm from "./InformeFuncionalidadesForm";
export default InformesFuncionalidadesForm;
